import { Injectable } from '@angular/core';
import { BaseWebPortalService, PortalId, WebPortal } from '@gk/gk-modules';
import { combineLatestWith, map, Observable } from 'rxjs';
import { OfficeDepartmentsService } from '../../../../../services/office-departments/office-departments.service';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsWebPortalService {
  private readonly webPortalIdsVisibleOnDepartmentsPage = [PortalId.MapPortal];
  private readonly visibleOnlyWhenDepartmentsArrayLengthIsMoreThanOne = true;

  constructor(
    private baseWebPortalService: BaseWebPortalService,
    private officeDepartmentsService: OfficeDepartmentsService,
  ) {}

  getWebPortalData(): Observable<WebPortal[]> {
    return this.baseWebPortalService.getWebPortalData().pipe(
      combineLatestWith(this.officeDepartmentsService.officeDepartments),
      map(([webPortal, officeDepartments]) =>
        !this.visibleOnlyWhenDepartmentsArrayLengthIsMoreThanOne ||
        officeDepartments?.length > 1
          ? webPortal?.filter(
              (portal) =>
                portal.show &&
                this.webPortalIdsVisibleOnDepartmentsPage.includes(
                  portal.portalId,
                ),
            )
          : [],
      ),
    );
  }
}
